import { render, staticRenderFns } from "./OverviewPanel.vue?vue&type=template&id=07d84b3a&scoped=true&"
import script from "./OverviewPanel.vue?vue&type=script&lang=js&"
export * from "./OverviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPanel.vue?vue&type=style&index=0&id=07d84b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d84b3a",
  null
  
)

export default component.exports